// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ta .assignmentTypeBox {
  height: 10rem;
  margin-bottom: 1rem;
  color: white;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  background: rgba(186, 186, 188, 1);
  background: -moz-radial-gradient(
    center,
    ellipse cover,
    rgba(186, 186, 188, 1) 0%,
    rgba(148, 143, 149, 1) 100%
  );
  background: -webkit-gradient(
    radial,
    center center,
    0px,
    center center,
    100%,
    color-stop(0%, rgba(186, 186, 188, 1)),
    color-stop(100%, rgba(148, 143, 149, 1))
  );
  background: -webkit-radial-gradient(
    center,
    ellipse cover,
    rgba(186, 186, 188, 1) 0%,
    rgba(148, 143, 149, 1) 100%
  );
  background: -o-radial-gradient(
    center,
    ellipse cover,
    rgba(186, 186, 188, 1) 0%,
    rgba(148, 143, 149, 1) 100%
  );
  background: -ms-radial-gradient(
    center,
    ellipse cover,
    rgba(186, 186, 188, 1) 0%,
    rgba(148, 143, 149, 1) 100%
  );
  background: radial-gradient(
    ellipse at center,
    rgba(186, 186, 188, 1) 0%,
    rgba(148, 143, 149, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#bababc', endColorstr='#948f95', GradientType=1 );

  display: flex;
  justify-content: center;
  align-items: center;
}

.ta .assignmentTypeBox .assignmentTypeText {
  width: 50%;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/assignments/createCourseTiles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC;;;;;GAKC;EACD;;;;;;;;GAQC;EACD;;;;;GAKC;EACD;;;;;GAKC;EACD;;;;;GAKC;EACD;;;;GAIC;EACD,oHAAoH;;EAEpH,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".ta .assignmentTypeBox {\n  height: 10rem;\n  margin-bottom: 1rem;\n  color: white;\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 14px;\n  background: rgba(186, 186, 188, 1);\n  background: -moz-radial-gradient(\n    center,\n    ellipse cover,\n    rgba(186, 186, 188, 1) 0%,\n    rgba(148, 143, 149, 1) 100%\n  );\n  background: -webkit-gradient(\n    radial,\n    center center,\n    0px,\n    center center,\n    100%,\n    color-stop(0%, rgba(186, 186, 188, 1)),\n    color-stop(100%, rgba(148, 143, 149, 1))\n  );\n  background: -webkit-radial-gradient(\n    center,\n    ellipse cover,\n    rgba(186, 186, 188, 1) 0%,\n    rgba(148, 143, 149, 1) 100%\n  );\n  background: -o-radial-gradient(\n    center,\n    ellipse cover,\n    rgba(186, 186, 188, 1) 0%,\n    rgba(148, 143, 149, 1) 100%\n  );\n  background: -ms-radial-gradient(\n    center,\n    ellipse cover,\n    rgba(186, 186, 188, 1) 0%,\n    rgba(148, 143, 149, 1) 100%\n  );\n  background: radial-gradient(\n    ellipse at center,\n    rgba(186, 186, 188, 1) 0%,\n    rgba(148, 143, 149, 1) 100%\n  );\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#bababc', endColorstr='#948f95', GradientType=1 );\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ta .assignmentTypeBox .assignmentTypeText {\n  width: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
